import { render, staticRenderFns } from "./textTeading.vue?vue&type=template&id=4fad4e94&scoped=true&"
import script from "./textTeading.vue?vue&type=script&lang=js&"
export * from "./textTeading.vue?vue&type=script&lang=js&"
import style0 from "./textTeading.vue?vue&type=style&index=0&id=4fad4e94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fad4e94",
  null
  
)

export default component.exports